import { CaixaListaModel } from "./../../model/caixa/caixalista.model";
import { CaixaModel } from "./../../model/caixa/caixa.model";
import { Observable } from "rxjs/Observable";
import { environment } from "./../../../environments/environment";
import { HttpHeaders, HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import GenericReturn from "app/model/generic/generic-return.model";
import { tap } from "rxjs/operators";

@Injectable()
export class CaixaService {
  apiURL = environment.API;
  private apiURLPRODESP = "";

  private apiURLPRODESPTOKEN = "";
  private httpOptionsPRODESP = {
    headers: new HttpHeaders({
      "Content-Type": "application/json",
      Authorization: "",
    }),
  };

  httpOptions = {
    headers: new HttpHeaders()
      .set("Content-Type", "application/json")
      .set("ticket", sessionStorage.getItem("ticket-ECM"))
      .set("Authorization", sessionStorage.getItem("tokenAuth")),
  };

  constructor(private httpClient: HttpClient) {}

  getUsuarioCaixa(userId: string): Observable<any> {
    return this.httpClient.get<any>(
      this.apiURL + `/view/user-caixa?userId=${userId}`,
      this.httpOptions
    );
  }

  getCaixaUnica(idCaixa: Number): Observable<CaixaModel> {
    return this.httpClient.get<CaixaModel>(
      this.apiURL + `/view/caixa-unica/${idCaixa}`,
      this.httpOptions
    );
  }

  auditoriaCaixa(caixaId: number): Observable<Array<any>> {
    return this.httpClient.get<Array<any>>(
      this.apiURL + `/auditoria-caixa/${caixaId}`,
      this.httpOptions
    );
  }

  rastreabilidadeCaixa(caixaId: number): Observable<Array<any>> {
    return this.httpClient.get<Array<any>>(
      this.apiURL + `/rastreabilidade-caixa/${caixaId}`,
      this.httpOptions
    );
  }

  rastreabilidadeCaixaMigrada(caixaId: number): Observable<any> {
    return this.httpClient.get<any>(
      this.apiURL + `/rastreabilidade-caixa-migradas/${caixaId}`,
      this.httpOptions
    );
  }

  getCodAlternativo(idCliente: number): Observable<Array<any>> {
    return this.httpClient.get<Array<any>>(
      this.apiURL + `/view/get-cod-alternativos/${idCliente}`,
      this.httpOptions
    );
  }

  saveCaixa(caixaModel: CaixaModel): Observable<CaixaModel> {
    return this.httpClient.post<CaixaModel>(
      this.apiURL + "/new/adicionar-caixa",
      caixaModel,
      this.httpOptions
    );
  }

  saveCaixaAndClose(caixaModel: CaixaModel): Observable<CaixaModel> {
    return this.httpClient.post<CaixaModel>(
      this.apiURL + "/new/adicionar-caixa-fechar",
      caixaModel,
      this.httpOptions
    );
  }

  getCaixasIdCliente(idCliente: number): Observable<Array<any>> {
    return this.httpClient.get<Array<any>>(
      this.apiURL + `/view/listar-caixas-cliente-view/${idCliente}`,
      this.httpOptions
    );
  }

  apagarCaixa(caixaId: number) {
    const headers = new HttpHeaders()
      .set("ticket", sessionStorage.getItem("ticket-ECM"))
      .set("Authorization", sessionStorage.getItem("tokenAuth"));

    return this.httpClient.delete(
      this.apiURL + `/delete/apagar-caixa/${caixaId}`,
      { headers, responseType: "text" }
    );
  }

  editarCaixa(caixa: CaixaModel): Observable<CaixaModel> {
    return this.httpClient.put<CaixaModel>(
      this.apiURL + "/edit/editar-caixa",
      caixa,
      this.httpOptions
    );
  }

  fecharCaixa(idCaixa: number) {
    const headers = new HttpHeaders()
      .set("ticket", sessionStorage.getItem("ticket-ECM"))
      .set("Authorization", sessionStorage.getItem("tokenAuth"));

    return this.httpClient.post(
      this.apiURL + `/fechar-caixa/${idCaixa}`,
      null,
      { headers, responseType: "text" }
    );
  }

  abrirCaixa(idCaixa: number) {
    const headers = new HttpHeaders()
      .set("ticket", sessionStorage.getItem("ticket-ECM"))
      .set("Authorization", sessionStorage.getItem("tokenAuth"));

    return this.httpClient.post(this.apiURL + `/abrir-caixa/${idCaixa}`, null, {
      headers,
      responseType: "text",
    });
  }

  pesquisaAvancada(
    clienteId: number,
    pesquisaCaixa: Array<any>
  ): Observable<Array<any>> {
    return this.httpClient.post<Array<any>>(
      this.apiURL + `/pesquisa-avancada/${clienteId}`,
      pesquisaCaixa,
      this.httpOptions
    );
  }

  relatorioCaixas(idsCaixas: Array<any>) {
    return this.httpClient.post<Array<any>>(
      this.apiURL + "/relatorio-caixas",
      idsCaixas,
      this.httpOptions
    );
  }

  pesquisaImplantacao(
    caixa: CaixaModel,
    clienteId: number,
    tpSolicitacao: String
  ): Observable<Array<any>> {
    return this.httpClient.post<Array<any>>(
      this.apiURL + `/pesquisa-implantacao/${clienteId}/${tpSolicitacao}`,
      caixa,
      this.httpOptions
    );
  }

  gerarRgs(qtdRgs: number, rgRestrito: boolean) {
    return this.httpClient.get(
      this.apiURL + `/gerar-caixas?quantidade=${qtdRgs}&restrito=${rgRestrito}`,
      this.httpOptions
    );
  }

  buscarNumeroCaixa(clienteId: number, areaId: number) {
    return this.httpClient.get(
      this.apiURL + `/get-last-numero-caixa/${clienteId}/${areaId}`,
      this.httpOptions
    );
  }

  buscarCaixasPorSolicitacao(solicitacaoId: number) {
    return this.httpClient.get(
      this.apiURL + `/get-caixa-solicitacao/${solicitacaoId}`,
      this.httpOptions
    );
  }

  listarRgs() {
    return this.httpClient.get(
      this.apiURL + "/listar-rgs-disponiveis",
      this.httpOptions
    );
  }

  addCacheCodAlternativo(cacheCodAlternativo) {
    return this.httpClient.post(
      this.apiURL + "/add-cache-cod-alternativo",
      cacheCodAlternativo,
      this.httpOptions
    );
  }

  listarCacheCodAlternativo(clienteId: number): Observable<Array<any>> {
    const headers = new HttpHeaders()
      .set("ticket", sessionStorage.getItem("ticket-ECM"))
      .set("Authorization", sessionStorage.getItem("tokenAuth"));

    return this.httpClient.get<Array<any>>(
      this.apiURL + `/lista-cache-cod-alternativo/${clienteId}`,
      { headers }
    );
  }

  cacheCodAlternativoUnico(clienteId: number) {
    return this.httpClient.get(
      this.apiURL + `/listar-cache-cod-alternativo-unico/${clienteId}`,
      this.httpOptions
    );
  }

  changeRGAutomatico(caixaId: number, status): any {
    return this.httpClient.get(
      this.apiURL + `/caixa/change-status-rg/${caixaId}/${status}`,
      this.httpOptions
    );
  }

  gerarRGConteudo(caixaId: number): any {
    return this.httpClient.get(
      this.apiURL + `/caixa/gerar-rg-conteudo/${caixaId}`,
      this.httpOptions
    );
  }

  downloadEtiquetas(idsCaixas: Array<any>) {
    const headers = new HttpHeaders()
      .set("ticket", sessionStorage.getItem("ticket-ECM"))
      .set("Authorization", sessionStorage.getItem("tokenAuth"));

    return this.httpClient.post(this.apiURL + "/etiqueta", idsCaixas, {
      headers,
      responseType: "text",
    });
  }

  buscarEnderecoPorCaixa(rgCaixa: String) {
    return this.httpClient.get(
      this.apiURL + `/get-endereco-caixa/${rgCaixa}`,
      this.httpOptions
    );
  }

  downloadRelatorioCaixas(
    clienteId: number,
    pesquisaCaixa: Array<any>
  ): Observable<GenericReturn<any>> {
    const headers = new HttpHeaders()
      .set("ticket", sessionStorage.getItem("ticket-ECM"))
      .set("Authorization", sessionStorage.getItem("tokenAuth"));

    return this.httpClient.post<GenericReturn<any>>(
      this.apiURL + `/download-relatorio-caixas/${clienteId}`,
      pesquisaCaixa,
      { headers }
    );
  }

  listNumeracaoCaixa(id: any): Observable<any> {
    return this.httpClient.get<any>(
      this.apiURL + `/numeracao-caixas-subarea?id=${id}`,
      this.httpOptions
    );
  }

  listNumeracaoCaixaArea(id: any): Observable<any> {
    return this.httpClient.get<any>(
      this.apiURL + `/numeracao-caixas-area?id=${id}`,
      this.httpOptions
    );
  }

  listNumeracaoCaixaAreaOrganizacao(id: any): Observable<any> {
    return this.httpClient.get<any>(
      this.apiURL + `/numeracao-caixas-area-organizacao?id=${id}`,
      this.httpOptions
    );
  }

  getProjetosPRODESP(): Observable<any> {
    return this.httpClient.get<any>(
      this.apiURLPRODESP,
      this.httpOptionsPRODESP
    );
  }

  getCamposProjeto(projetoId: number): Observable<any> {
    const headers = new HttpHeaders()
      .set("Authorization", sessionStorage.getItem("tokenAuth"))
      .set("Ticket", sessionStorage.getItem("ticket-ECM"))
      .set("Content-Type", "application/json");

    return this.httpClient.get<any>(
      this.apiURL + `/prodesp/projetos/${projetoId}/campos`,
      { headers }
    );
  }

  getProjetosPRODESPLocal(): Observable<any> {
    const headers = new HttpHeaders()
      .set("Authorization", sessionStorage.getItem("tokenAuth"))
      .set("Ticket", sessionStorage.getItem("ticket-ECM"))
      .set("Content-Type", "application/json");

    return this.httpClient.get<any>(this.apiURL + `/prodesp/projetos`, {
      headers,
    });
  }

  listarClassificacoesPRODESP(): Observable<any> {
    const headers = new HttpHeaders()
      .set("Authorization", sessionStorage.getItem("tokenAuth"))
      .set("Ticket", sessionStorage.getItem("ticket-ECM"))
      .set("Content-Type", "application/json");

    return this.httpClient.get<any>(
      this.apiURL + `/prodesp/classificacoes/421`,
      {
        headers,
      }
    );
  }
  // getProjetosPRODESPLocal(): Observable<any> {
  //   const baseUrl = encodeURIComponent(
  //     "https://despapelizasp.api-hml.rota.sp.gov.br"
  //   );
  //   const clienteId = "421";
  //   const scope = encodeURIComponent(
  //     "api:integrador.despapelizasp api:integrador.despapelizasp-arquivos"
  //   );
  //   const clientSecret = "27ef24a9-bf43-41c4-86b4-da59433016de";
  //   const clientId = "prodesp.despapelizasp-sigad-skybox";
  //   const tokenUrl = encodeURIComponent(
  //     "https://rhsso.idp-hml.sp.gov.br/auth/realms/idpsp/protocol/openid-connect/token"
  //   );

  //   const url = `http://localhost:5580/api/prodesp/projetos?baseUrl=${baseUrl}&clienteId=${clienteId}&scope=${scope}&clientSecret=${clientSecret}&clientId=${clientId}&tokenUrl=${tokenUrl}&=`;

  //   const headers = new HttpHeaders()
  //     .set("Authorization", sessionStorage.getItem("tokenAuth"))
  //     .set("ticket", sessionStorage.getItem("ticket-ECM"))
  //     .set("Content-Type", "application/json");

  //   return this.httpClient.get<any>(url, { headers });
  // }

  getTokenPRODESP(): Observable<any> {
    const body = new HttpParams()
      .set("grant_type", "client_credentials")
      .set("client_id", "")
      .set("client_secret", "")
      .set("scope", "");

    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
    });

    return this.httpClient.post<any>(this.apiURLPRODESPTOKEN, body.toString(), {
      headers,
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/service/caixa/caixa.service.ts